import React, { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Button } from "reactstrap";
import { FaEllipsisV, FaDownload } from "react-icons/fa";
import axios from "axios";
import { useSelector } from "react-redux";

const GalleryTab = ({ partnerId }) => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  const { AuthReducer: { auth } } = useSelector((state) => state);

  useEffect(() => {
    fetchPartnerGallery();
  }, [partnerId]);

  const fetchPartnerGallery = async () => {
    try {
      const response = await axios.get(
        `/api/admin/v1/partner-gallery/${partnerId}`,
        {
          headers: { Authorization: `Bearer ${auth?.token}` },
        }
      );
      setGalleries(response.data.galleries || []);
    } catch (error) {
      console.error("Failed to fetch partner gallery");
    } finally {
      setLoading(false);
    }
  };

  const downloadMedia = (fileName) => {
    const url = process.env.REACT_APP_IMAGE_URL + `/${fileName}`;
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) return <Spinner />;

  return (
    <div>

      <style>{`
        .place-block {
          border: 1px solid #eee;
          padding: 18px;
          border-radius: 14px;
          background: #fff;
          margin-bottom: 25px;
        }
        .place-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }
        .place-title {
          font-size: 18px;
          font-weight: bold;
        }
        .gallery-card {
          border-radius: 12px;
          overflow: hidden;
          background: #fff;
          border: 1px solid #e5e5e5;
          box-shadow: 0px 2px 5px rgba(0,0,0,0.1);
          position: relative;
        }
        .gallery-img, .gallery-video {
          width: 100%;
          height: 160px;
          object-fit: cover;
        }
        .download-btn {
          position: absolute;
          top: 8px;
          right: 8px;
          background: rgba(0,0,0,0.6);
          border: none;
          color: #fff;
          border-radius: 50%;
          padding: 6px;
          cursor: pointer;
        }
      `}</style>

      {galleries.map((gallery) => (
        <div className="place-block" key={gallery.id}>
          <div className="place-header">
            <div className="place-title text-dark">{gallery.place?.place_name}</div>
            <FaEllipsisV size={20} style={{ cursor: "pointer", color: "#686565ff" }} />
          </div>

          <Row className="mt-3">
            {gallery.gallery_images?.map((media, index) => (
              <Col md={3} xs={6} key={index} className="mb-3">
                <div className="gallery-card">
                  {media.type === "video" ? (
                    <video
                      className="gallery-video"
                      controls
                      src={process.env.REACT_APP_IMAGE_URL + `/${media.gallery_image}`}
                    />
                  ) : (
                    <img
                      src={process.env.REACT_APP_IMAGE_URL + `/${media.gallery_image}`}
                      alt="gallery"
                      className="gallery-img"
                    />
                  )}
                  <button
                    className="download-btn"
                    onClick={() => downloadMedia(media.gallery_image)}
                  >
                    <FaDownload size={8} />
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
};

export default GalleryTab;
